@if (pai || filhos.length) {
  <!-- ===== SPLIT DE PEDIDO ===== -->
  <div class="section-title">
    <mat-icon>call_split</mat-icon>
    <span>Split de pedido</span>
  </div>

  @if (pai) {
    <!-- Compra aberta é filha: de onde veio e se ainda pode voltar ao pai. -->
    <div class="ced-spl-item">
      <div class="ced-spl-text">
        Criado pelo split de <b>Pedido {{ codigoCompra(pai.codigo) }}</b> em {{ pai.dataSplit | date: 'dd/MM/yyyy' }} — {{ pai.motivo }}.
        {{ codigoCompra(pai.codigo) }} está em {{ pai.nomeEtapaAtual }} (saiu de {{ pai.nomeEtapaNoSplit }} no split).
      </div>
      <div class="ced-spl-actions">
        <span [matTooltip]="motivoBloqueio(pai)" [matTooltipDisabled]="!motivoBloqueio(pai)">
          <button mat-stroked-button type="button" class="btn-secondary btn-spinner"
            [class.btn-loading]="revertendoLado === pai"
            [disabled]="!!motivoBloqueio(pai) || !!revertendoLado"
            [attr.aria-label]="revertendoLado === pai ? 'Revertendo split' : 'Reverter split'" (click)="reverter(pai)">
            <mat-icon class="material-symbols-outlined">undo</mat-icon>
            Reverter split
            @if (revertendoLado === pai) { <mat-spinner diameter="20"></mat-spinner> }
          </button>
        </span>
        @if (!motivoBloqueio(pai)) {
          <span class="ced-spl-hint">
            Reversão liberada enquanto {{ codigo }} continuar em {{ nomeEtapaAtual }} e {{ codigoCompra(pai.codigo) }} em {{ pai.nomeEtapaNoSplit }}.
          </span>
        }
      </div>
    </div>
  }

  @for (filho of filhos; track filho.idCompra) {
    <!-- Compra aberta é pai: cada filha pode ser revertida individualmente. -->
    <div class="ced-spl-item">
      <div class="ced-spl-text">
        <b>Pedido {{ codigoCompra(filho.codigo) }}</b> — {{ filho.nomeEtapaAtual }} — criado em {{ filho.dataSplit | date: 'dd/MM/yyyy' }} ({{ filho.motivo }})
      </div>
      <div class="ced-spl-actions">
        <span [matTooltip]="motivoBloqueio(filho)" [matTooltipDisabled]="!motivoBloqueio(filho)">
          <button mat-stroked-button type="button" class="btn-secondary btn-spinner"
            [class.btn-loading]="revertendoLado === filho"
            [disabled]="!!motivoBloqueio(filho) || !!revertendoLado"
            [attr.aria-label]="revertendoLado === filho ? 'Revertendo split' : 'Reverter split'" (click)="reverter(filho)">
            <mat-icon class="material-symbols-outlined">undo</mat-icon>
            Reverter split
            @if (revertendoLado === filho) { <mat-spinner diameter="20"></mat-spinner> }
          </button>
        </span>
        @if (!motivoBloqueio(filho)) {
          <span class="ced-spl-hint">
            Reversão liberada enquanto {{ codigoCompra(filho.codigo) }} continuar em {{ filho.nomeEtapaNoSplit }} e {{ codigo }} em {{ nomeEtapaAtual }}.
          </span>
        }
      </div>
    </div>
  }
}
